




import { Vue, Component, Prop } from 'vue-property-decorator';
import AmapAdapter from '@/common/util/aMap';
import { bd09ToGcj02 } from '@/common/util/mapUtil';



@Component({})
export default class TopPanel extends Vue {
    amapAdapter: AmapAdapter;

    myGeo: any;
    map: any;
    map1: any;
    @Prop()
    public detailData2:any;

    mounted() {
        this.$nextTick(() => {
            this.amapAdapter = new AmapAdapter('dituContent', 119.446448, 32.164418, 5);
            this.amapAdapter.addMapControl('LB',35,65,25,30)
        });
    }

    public marker = null;
    public polyline = null;
    public index = 0;
    public gos:any = ''

    public lineArr = [];

    public startIcon = 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/SLSUpload/20220902/327385257308229.png';
    public carIcon = 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/upload/1C2A9AA713942D3FC8F230378FF2D158.png';
    public endIcon = 'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/SLSUpload/20220902/327385344864325.png';
    // public endIcon2 = require('https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/SLSUpload/20220902/327385344864325.png');
    public movingCar1 = 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/car.png';

    setPoint(arr, carCode) {
        // this.initMap();
        this.amapAdapter.resetPath();

        let that = this;
        if (!arr) {
            // this.$alert('没有定位记录');
            return;
        }
        this.lineArr = [];
        arr.forEach((item) => {
            this.lineArr.push(new AMap.LngLat(...bd09ToGcj02(item.longitude, item.latitude)));
        });
        console.log('this.lineArr' + JSON.stringify(this.lineArr));
        this.lineArr.forEach((item, i) => {
            // if(i == 0 ) {
            //     return
            // }
          var content =
                '<div>车牌号：' +
                carCode +
                '</div>' +
                '<div>采集时间：' +
                arr[i].locationTime +
                '</div>' +
                '<div>采集地址：' +
                arr[i].address +
                '</div>';

           if (i == 0) {
                if(item.lng>0&&item.lat>0){
                    this.amapAdapter.addMarker({ lnglat: item, icon: this.endIcon, content: content }, 41, 51,-20,-25)
                }
            } else if (i == this.lineArr.length - 1) {
                if(item.lng>0&&item.lat>0){
                    this.amapAdapter.addMarker({ lnglat: item, icon: this.startIcon, content: content }, 48, 48,-24,-24)
                }
            } else {
                this.amapAdapter.addMarker({ lnglat: item, icon: this.carIcon, content: content }, 41, 51,-20,-25)
            }
        });
        // if (arr.length > 0) {
        //     this.amapAdapter.map.setZoomAndCenter(8,[arr[0].longitude, arr[0].latitude]);
        // }
    }

    // goPoint 方法 本体无调用，父类也无调用 这里先去掉

}
